export const HOME = "/home";
export const BROWSE = "/browse";
export const SIGNIN = "/signin";
export const SIGNUP = "/signup";
